import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

function Terms() {
  const { t } = useTranslation();
  return (
    <div className="max-w-3xl mx-auto my-10 px-4 text-white">
      <h1 className="text-4xl font-bold mb-4">
        {t('terms_title')}
      </h1>

      <p className="mb-4">{t('terms_content1')}</p>
      <ul className="list-disc list-inside mb-4">
        <li>{t('terms_content2_item1')}</li>
        <li>{t('terms_content2_item2')}</li>
      </ul>
      <p className="mb-4">{t('terms_content3')}</p>
      <p className="mb-4">
        {t('terms_provider')}
      </p>
      <p className="mb-4">
        {t('terms_contact')}
      </p>
      <p className="mb-4">
        This document was generated with the use of the{" "}
        <a
          href="https://www.iubenda.com/terms-and-conditions-generator"
          className="text-violet-400 underline"
        >
          Terms of Service generator
        </a>.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">{t('terms_glanceHeading')}</h2>
      <p className="mb-4">
        {t('terms_glanceText')}
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">{t('terms_usageHeading')}</h2>
      <p className="mb-4">
        {t('terms_usageText')}
      </p>

      <h3 className="text-xl font-semibold mt-4 mb-2">{t('terms_registrationHeading')}</h3>
      <p className="mb-4">
        {t('terms_registrationText')}
      </p>

      <h4 className="text-lg font-semibold mt-2 mb-1">{t('terms_registrationConditionsHeading')}</h4>
      <ul className="list-disc list-inside mb-4">
        <li>{t('terms_registrationCondition1')}</li>
        <li>{t('terms_registrationCondition2')}</li>
        <li>{t('terms_registrationCondition3')}</li>
      </ul>

      <h3 className="text-xl font-semibold mt-4 mb-2">{t('terms_obligationsHeading')}</h3>
        <p className="mb-4">
        {t('terms_obligationsText')}
        </p>
        <ul className="list-disc list-inside mb-4">
        <li>{t('terms_obligation1')}</li>
        <li>{t('terms_obligation2')}</li>
        <li>{t('terms_obligation3')}</li>
        <li>{t('terms_obligation4')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-4 mb-2">{t('terms_privacyHeading')}</h3>
        <p className="mb-4">
        {t('terms_privacyText')}
        </p>

        <h3 className="text-xl font-semibold mt-4 mb-2">{t('terms_liabilityHeading')}</h3>
        <p className="mb-4">
        {t('terms_liabilityText')}
        </p>

        <h3 className="text-xl font-semibold mt-4 mb-2">{t('terms_governingHeading')}</h3>
        <p className="mb-4">
        {t('terms_governingText')}
        </p>

        <h3 className="text-xl font-semibold mt-4 mb-2">{t('terms_changesHeading')}</h3>
            <p className="mb-4">
            {t('terms_changesText')}
            </p>

      <Link to="/" className="text-violet-400 underline mt-6 inline-block">
        {t('terms_backToHome')}
      </Link>
    </div>
  );
}

export default Terms;